import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import AppContextProvider from "./context/AppContext.jsx";
import { LoaderProvider } from "./context/LoadingContext.tsx";
import FullScreenLoader from "./components/Loading.tsx";
import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://da0fe0dbf15d80ac23ae9072c8b74e8a@o4508903766163456.ingest.us.sentry.io/4508903826587648",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/huub2dkrj1.execute-api.ap-south-1.amazonaws\.com\/production/],

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <LoaderProvider>
    <BrowserRouter>
      <AppContextProvider>
        <App />
        <FullScreenLoader />
      </AppContextProvider>
    </BrowserRouter>
  </LoaderProvider>
);
